<template>
  <div>
    <v-card
      color="background"
      flat>
      <v-card-subtitle
        class="px-0 pb-0 caption">
        NUEVO CONTRATO
      </v-card-subtitle>

      <v-card-title
        class="px-0 pt-0 pb-5">
        Seleccioná el tipo de contrato
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
          <div
            class="text-subtitle-1 black--text">
            Tipo de contrato
          </div>
          <v-row>
            <v-col
              cols="6">
              <v-btn-toggle
                v-model="contract.contractType"
                >
                <v-btn
                  value="rent"
                  color="white"
                  active-class="blue lighten-1 white--text"
                  block>
                  Alquiler
                </v-btn>
                <v-btn
                  value="sell"
                  color="white"
                  block
                  active-class="blue lighten-1 white--text">
                  Venta
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row
            v-if="properties.length > 0"
            >
            <v-col
              cols="6">
              <v-autocomplete
                :rules="rules"
                :items="properties"
                :item-text="v => `${v.address.street} ${v.address.number} ${v.address.unit ? v.address.unit : ''}, ${v.address.city}, ${v.address.state}`"
                item-value="id"
                v-model="contract.propertyId"
                filled
                hint="*Obligatorio"
                persistent-hint
                label="Propiedad">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row
            v-else
            >
            <v-col
              cols="6">
              <v-card
                color="transparent" 
                flat>
                  <span>No hay propiedades disponibles para crear un contrato. Puede cargar una haciendo <router-link :to="{ name: 'CreateProperty' }">{{ $t('action.click_here') }}</router-link>.</span>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <div
      class="pt-6 text-right">
      <v-btn
        @click="$router.push({ name: 'Contracts' })"
        text>
        {{ fetchedContract.id ? 'Cerrar' : 'Cancelar' }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="loading"
        :loading="loading"
        @click="nextStep">
        Siguiente
      </v-btn>
    </div>
  </div>
</template>

<script>
import { PropertiesList } from '@/graphql/queries/property'
import { CreateContract, EditContract } from '@/graphql/mutations/contracts'

export default {
  data () {
    return {
      valid: true,
      loading: false,
      address: null,
      contract: {
        id: null,
        contractType: "rent",
        name: null,
        propertyId: null,
        state: 'draft'
      },
      rules: [
        v => !!v || '*Obligatorio'
      ],
      properties: [] 
    }
  },

  props: {
    fetchedContract: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          contractType: "rent",
          name: null,
          property: {
            id: null
          }
        }
      }
    }
  },

  watch: {
    'contract.contractType': {
      handler () {
        this.fetchProperties('no-cache')
      }
    },

    'fetchedContract.id': {
      handler () {
        this.fetchProperties('no-cache', true)
      }
    }
  },

  mounted () {
    this.fetchProperties('no-cache', true)
  },

  methods: {
    nextStep () {
      if (this.valid) this.valid = this.$refs.form.validate()

      if (this.valid) {
        if (this.contract.id) {
          this.editContract()  
        } else {
          this.createContract()  
        }
      }
    },

    createContract () {
      if (this.valid) this.$refs.form.validate()

      if (this.valid) {
        this.loading = true
        this.$apollo.mutate({
          mutation: CreateContract,
          variables: {
            input: {
              attributes: this.contract,
              propertyId: this.contract.propertyId,
            }
          }
        }).then( res => {
          this.$emit('continue', res.data.createContract.contract)
          this.loading = false
        })
      }
    },

    editContract () {
      if (this.valid) this.$refs.form.validate()

      if (this.valid) {
        this.$apollo.mutate({
          mutation: EditContract,
          variables: {
            input: {
              attributes: this.contract,
              contractId: this.contract.id,
            }
          }
        }).then( res => {
          this.$emit('continue', res.data.editContract.contract)
        })
      }
    },

    fetchProperties (policy, firstLoad = false) {
      this.$apollo.query({
        query: PropertiesList,
        variables: {
          noPaginate: true,
          operationType: this.contract.contractType,
          free: true,
          contractId: this.fetchedContract.id,
          filters: {
            state: ['published', 'booked']
          }
        },
        fetchPolicy: policy
      }).then(res => {
        this.properties = res.data.properties.properties
        this.properties.forEach ( property => {
          delete property.disabled
        })
        if (firstLoad) {
          this.fillData()
        }
      })
    },

    fillData () {
      if (this.fetchedContract.id) {
        this.contract.id = this.fetchedContract.id
        this.contract.state = this.fetchedContract.state
        this.contract.name = this.fetchedContract.name
        this.contract.contractType = this.fetchedContract.contractType
        this.contract.propertyId = this.fetchedContract.property.id
      }
    },
  },
}
</script>

<style>
.active-btn {
  border-color: red !important;
}

map > div {
  border-radius: 10px;
}
</style>
